import {
  GET_APPOINTMENTS,
  GET_APPOINTMENTS_FAIL,
  GET_APPOINTMENTS_SUCCESS,
  GET_APPOINTMENTS_DETAILS,
  GET_APPOINTMENTS_DETAILS_FAIL,
  GET_APPOINTMENTS_DETAILS_SUCCESS,
  ADD_NEW_APPOINTMENTS,
  ADD_APPOINTMENTS_SUCCESS,
  ADD_APPOINTMENTS_FAIL,
  UPDATE_APPOINTMENTS,
  UPDATE_APPOINTMENTS_SUCCESS,
  UPDATE_APPOINTMENTS_FAIL,
  DELETE_APPOINTMENTS,
  DELETE_APPOINTMENTS_SUCCESS,
  DELETE_APPOINTMENTS_FAIL,
  CONFIRM_APPOINTMENTS,
  CONFIRM_APPOINTMENTS_SUCCESS,
  CONFIRM_APPOINTMENTS_FAIL,
  COMPLETE_APPOINTMENTS,
  COMPLETE_APPOINTMENTS_SUCCESS,
  COMPLETE_APPOINTMENTS_FAIL,
  ADD_REMARKS_APPOINTMENTS,
  ADD_REMARKS_APPOINTMENTS_SUCCESS,
  ADD_REMARKS_APPOINTMENTS_FAIL,
  RESET_APPOINTMENTS_STATE,
} from "./actionTypes";

export const getAppointments = ({ length, sort, page, name, date, status, patientID, sort_by }) => ({
  type: GET_APPOINTMENTS,
  payload: { length, sort, page, name, date, status, patientID, sort_by },
});

export const getAppointmentsSuccess = appointments => ({
  type: GET_APPOINTMENTS_SUCCESS,
  payload: appointments,
});

export const getAppointmentsFail = error => ({
  type: GET_APPOINTMENTS_FAIL,
  payload: error,
});

export const getAppointmentsDetails = ({ id }) => ({
  type: GET_APPOINTMENTS_DETAILS,
  payload: { id },
});

export const getAppointmentsDetailsSuccess = appointments => ({
  type: GET_APPOINTMENTS_DETAILS_SUCCESS,
  payload: appointments,
});

export const getAppointmentsDetailsFail = error => ({
  type: GET_APPOINTMENTS_DETAILS_FAIL,
  payload: error,
});

//add 
export const addNewAppointments = appointments => ({
  type: ADD_NEW_APPOINTMENTS,
  payload: appointments,
});

export const addAppointmentsSuccess = appointments => ({
  type: ADD_APPOINTMENTS_SUCCESS,
  payload: appointments,
});

export const addAppointmentsFail = error => ({
  type: ADD_APPOINTMENTS_FAIL,
  payload: error,
});

//update 
export const updateAppointments = ({ id, appointments }) => ({
  type: UPDATE_APPOINTMENTS,
  payload: { id, appointments },
});

export const updateAppointmentsSuccess = appointments => ({
  type: UPDATE_APPOINTMENTS_SUCCESS,
  payload: appointments,
});

export const updateAppointmentsFail = error => ({
  type: UPDATE_APPOINTMENTS_FAIL,
  payload: error,
});

//update 
export const completeAppointments = ({ id, appointments }) => ({
  type: COMPLETE_APPOINTMENTS,
  payload: { id, appointments },
});

export const completeAppointmentsSuccess = appointments => ({
  type: COMPLETE_APPOINTMENTS_SUCCESS,
  payload: appointments,
});

export const completeAppointmentsFail = error => ({
  type: COMPLETE_APPOINTMENTS_FAIL,
  payload: error,
});

//remarks 
export const addRemakrsAppointments = ({ id, appointments }) => ({
  type: ADD_REMARKS_APPOINTMENTS,
  payload: { id, appointments },
});

export const addRemarksAppointmentsSuccess = appointments => ({
  type: ADD_REMARKS_APPOINTMENTS_SUCCESS,
  payload: appointments,
});

export const addRemarksAppointmentsFail = error => ({
  type: ADD_REMARKS_APPOINTMENTS_FAIL,
  payload: error,
});

//delete 
export const deleteAppointments = ({ id, msg }) => ({
  type: DELETE_APPOINTMENTS,
  payload: { id, msg },
});

export const deleteAppointmentsSuccess = appointments => ({
  type: DELETE_APPOINTMENTS_SUCCESS,
  payload: appointments,
});

export const deleteAppointmentsFail = error => ({
  type: DELETE_APPOINTMENTS_FAIL,
  payload: error,
});

//confirm 
export const confirmAppointments = ({ id, appointments }) => ({
  type: CONFIRM_APPOINTMENTS,
  payload: { id, appointments },
});

export const confirmAppointmentsSuccess = appointments => ({
  type: CONFIRM_APPOINTMENTS_SUCCESS,
  payload: appointments,
});

export const confirmAppointmentsFail = error => ({
  type: CONFIRM_APPOINTMENTS_FAIL,
  payload: error,
});

//reset
export const resetAppointmentsState = () => {
  return {
    type: RESET_APPOINTMENTS_STATE,
  }
}


